import { AuthenticationService } from "../services";

export const logout = async () => {
  const auth = new AuthenticationService();
  await auth.logOut();
  window.location.href = "/login";
};
